function initMenuDrawerPanels() {
  const menu = document.querySelector('.menu-drawer');
  if (!menu) return;

  // New layer structure: root/children/grandchildren drawers are managed by header-drawer.js
  if (menu.classList.contains('menu-drawer--root')) return;

  const panels = menu.querySelectorAll('.mm-panel');
  const openButtons = menu.querySelectorAll('[data-menu-open]');
  const backButtons = menu.querySelectorAll('[data-menu-back]');
  const closeButton = menu.querySelector('[data-menu-close]');

  function showPanel(id) {
    panels.forEach((p) => p.classList.remove('is-active'));
    const target = menu?.querySelector('[data-panel="' + id + '"]');
    if (target) target.classList.add('is-active');
  }

  openButtons.forEach((btn) => {
    btn.addEventListener('click', function () {
      const target = this.dataset.target;
      showPanel(target);
    });
  });

  backButtons.forEach((btn) => {
    btn.addEventListener('click', function () {
      const target = this.dataset.backTarget;
      showPanel(target);
    });
  });

  if (closeButton) {
    closeButton.addEventListener('click', function () {
      menu.classList.remove('is-open');
      showPanel('root');
    });
  }

  const accordions = menu.querySelectorAll('[data-accordion]');
  accordions.forEach((acc) => {
    const toggle = acc.querySelector('[data-accordion-toggle]');
    const body = acc.querySelector('[data-accordion-body]');
    const icon = acc.querySelector('[data-accordion-icon]');

    if (!toggle || !body) return;

    if (body.classList.contains('is-open')) {
      toggle.setAttribute('aria-expanded', 'true');
    } else {
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      const isOpen = body.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (icon) icon.textContent = isOpen ? '−' : '+';
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMenuDrawerPanels);
} else {
  initMenuDrawerPanels();
}
